export default __webpack_public_path__ + "static/media/peperoncino.6ff80d28.png";